import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../core/constants/routes';
import { STORAGE_KEYS } from '../core/constants/storage';

const NavigationContext = createContext();

export const useNavigation = () => {
  const context = useContext(NavigationContext);
  if (!context) {
    throw new Error('useNavigation must be used within a NavigationProvider');
  }
  return context;
};

export const NavigationProvider = ({ children }) => {
  const navigate = useNavigate();
  const [showSignIn, setShowSignIn] = useState(false);
  const [showSignUp, setShowSignUp] = useState(false);

  const openSignIn = useCallback(() => {
    setShowSignIn(true);
    setShowSignUp(false);
  }, []);

  const openSignUp = useCallback(() => {
    setShowSignUp(true);
    setShowSignIn(false);
  }, []);

  const closeModals = useCallback(() => {
    setShowSignIn(false);
    setShowSignUp(false);
  }, []);

  const goToDashboard = useCallback(() => {
    // RAS-41: Vérifier s'il y a un redirect après auth (ex: depuis PublicActivityPage)
    const redirect = sessionStorage.getItem(STORAGE_KEYS.REDIRECT_AFTER_AUTH);
    if (redirect) {
      sessionStorage.removeItem(STORAGE_KEYS.REDIRECT_AFTER_AUTH);
      navigate(redirect, { replace: true });
    } else {
      navigate(ROUTES.DASHBOARD);
    }
    setShowSignIn(false);
    setShowSignUp(false);
  }, [navigate]);

  const value = useMemo(() => ({
    showSignIn,
    showSignUp,
    openSignIn,
    openSignUp,
    closeModals,
    goToDashboard
  }), [showSignIn, showSignUp, openSignIn, openSignUp, closeModals, goToDashboard]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
};